import React from 'react';
import { bool, object } from 'prop-types';
import glamorous from 'glamorous';

import CSS from './styles.css';
import FilterBar from './FilterBar';
import AnnotationList from './AnnotationList';
import FilterPanel from 'Components/FilterPanel';


const NotebookViews = ({ isMobile, styles, highlights }) => {
  return (
    <div className={ CSS['container'] } style={ styles }>
      {highlights.length === 0
        ? null
        : <FilterBar />
      }
      <AnnotationList />

      {/*check rendering here: include isFilterPanelOpen or not?*/}
      {isMobile
        ? <FilterPanel />
        : null
      }

    </div>
  );
};

NotebookViews.propTypes = {};


export default NotebookViews;
